import { RootState } from "@/app/store/type";
import { createSelector } from "@reduxjs/toolkit";
import { filterDataType } from "./types";

export const selectBuildingsIsLoading = (state: RootState) => state.buildings.isLoading == true;
export const selectBuildingsError = (state: RootState) => state.buildings.error;

export const selectAllBuildings = (state: RootState) => state.buildings.data;

export const selectBuildingsInProcess = createSelector(
  [selectAllBuildings],
  (buildings) => (buildings ?? []).filter((b) => b.status === 'in_process')
);

export const selectBuildingById = (id: string) => createSelector(
    [selectAllBuildings],
    (buildings) => (buildings ?? []).find(item => item.id == id)
)

export const selectBuildingByDirection = (id: string) =>
  createSelector(
    [selectBuildingById(id), selectAllBuildings],
    (building, buildings) => {
      if (!building) return [];

      return (buildings ?? []).filter(
        (item) => item.direction === building.direction && item.id !== building.id
      );
    }
  );


export const makeSelectFilteredBuildings = () =>
  createSelector(
    [selectAllBuildings, (_: RootState, filters: filterDataType) => filters],
    (buildings, filters) => {
      if (!buildings) return [];

      return buildings.filter((building) => {
        const {
          direction,
          price_from,
          price_to,
          aria_to,
          floor_to,
          parking
        } = filters;

        if (direction && building.direction == direction) return false;

        const price = building.price?.from ?? 0;
        if (price_from && price < price_from) return false;
        if (price_to && price > price_to) return false;

        const area = building.totalArea?.value ?? 0;
        if (aria_to && area > aria_to) return false;

        const floors = building.floors ?? 0;
        if (floor_to && floors > floor_to) return false;

        if (parking && !building.transport?.parking) return false;

        return true;
      });
    }
  );